{
  "header": {
    "title": "Manage PSS",
    "description": "Review PSS registrations and manage linked generating companies."
  },
  "stats": [
    {
      "label": "Total PSS",
      "icon": "\u2302",
      "tone": "blue"
    },
    {
      "label": "Active PSS",
      "icon": "\u25ce",
      "tone": "green"
    },
    {
      "label": "Inactive PSS",
      "icon": "\u25cc",
      "tone": "red"
    },
    {
      "label": "Total Capacity",
      "suffix": "MW",
      "icon": "\u26a1",
      "tone": "violet"
    },
    {
      "label": "PSS with Generators",
      "icon": "\u25a6",
      "tone": "blue"
    },
    {
      "label": "PSS with Meters",
      "icon": "\u25eb",
      "tone": "green"
    }
  ],
  "filters": {
    "state": [
      "All",
      "Maharashtra"
    ],
    "district": [
      "All",
      "Aurangabad",
      "Kolhapur",
      "Nashik",
      "Mumbai",
      "Amravati",
      "Ahmednagar",
      "Solapur",
      "Jalgaon",
      "Latur",
      "Satara",
      "Pune",
      "Nagpur"
    ],
    "voltageLevelKv": [
      "All",
      "132",
      "220",
      "400"
    ],
    "status": [
      "All",
      "Active",
      "Inactive"
    ],
    "qca": [
      "All",
      "MH_MANIKARAN (QCA-001)",
      "MH_RECONNECT (QCA-002)",
      "MH_STATKRAFT (QCA-003)",
      "MH_VEDANJAY (QCA-004)",
      "MH_KREATE (QCA-005)",
      "MH_TPREL (QCA-006)",
      "MH_CLEAN (QCA-007)",
      "MH_WALWHAN (QCA-008)",
      "MH_MSEDCL (QCA-009)",
      "MH_SHARDA (QCA-010)"
    ]
  },
  "rows": [
    {
      "code": "PSS-001",
      "name": "Ahmednagar PSS 1",
      "qcaCode": "QCA-001",
      "qcaName": "MH_MANIKARAN",
      "state": "Maharashtra",
      "district": "Aurangabad",
      "voltageLevelKv": 132,
      "installedCapacityMw": 200,
      "feederCount": 3,
      "generatorCount": 5,
      "meterCount": 8,
      "status": "Active",
      "commissionDate": "03-Jan-2024"
    },
    {
      "code": "PSS-002",
      "name": "Solapur PSS 2",
      "qcaCode": "QCA-002",
      "qcaName": "MH_RECONNECT",
      "state": "Maharashtra",
      "district": "Kolhapur",
      "voltageLevelKv": 220,
      "installedCapacityMw": 400,
      "feederCount": 6,
      "generatorCount": 5,
      "meterCount": 8,
      "status": "Active",
      "commissionDate": "06-Feb-2024"
    },
    {
      "code": "PSS-003",
      "name": "Jalgaon PSS 3",
      "qcaCode": "QCA-003",
      "qcaName": "MH_STATKRAFT",
      "state": "Maharashtra",
      "district": "Nashik",
      "voltageLevelKv": 132,
      "installedCapacityMw": 200,
      "feederCount": 3,
      "generatorCount": 5,
      "meterCount": 8,
      "status": "Active",
      "commissionDate": "09-Mar-2024"
    },
    {
      "code": "PSS-004",
      "name": "Kolhapur PSS 4",
      "qcaCode": "QCA-004",
      "qcaName": "MH_VEDANJAY",
      "state": "Maharashtra",
      "district": "Mumbai",
      "voltageLevelKv": 132,
      "installedCapacityMw": 100,
      "feederCount": 2,
      "generatorCount": 5,
      "meterCount": 7,
      "status": "Active",
      "commissionDate": "12-Apr-2024"
    },
    {
      "code": "PSS-005",
      "name": "Jalgaon PSS 5",
      "qcaCode": "QCA-005",
      "qcaName": "MH_KREATE",
      "state": "Maharashtra",
      "district": "Amravati",
      "voltageLevelKv": 132,
      "installedCapacityMw": 150,
      "feederCount": 2,
      "generatorCount": 5,
      "meterCount": 7,
      "status": "Active",
      "commissionDate": "15-May-2024"
    },
    {
      "code": "PSS-006",
      "name": "Solapur PSS 6",
      "qcaCode": "QCA-006",
      "qcaName": "MH_TPREL",
      "state": "Maharashtra",
      "district": "Ahmednagar",
      "voltageLevelKv": 400,
      "installedCapacityMw": 600,
      "feederCount": 8,
      "generatorCount": 5,
      "meterCount": 7,
      "status": "Active",
      "commissionDate": "18-Jun-2024"
    },
    {
      "code": "PSS-007",
      "name": "Nashik PSS 7",
      "qcaCode": "QCA-007",
      "qcaName": "MH_CLEAN",
      "state": "Maharashtra",
      "district": "Solapur",
      "voltageLevelKv": 400,
      "installedCapacityMw": 500,
      "feederCount": 7,
      "generatorCount": 5,
      "meterCount": 7,
      "status": "Active",
      "commissionDate": "21-Jul-2024"
    },
    {
      "code": "PSS-008",
      "name": "Amravati PSS 8",
      "qcaCode": "QCA-008",
      "qcaName": "MH_WALWHAN",
      "state": "Maharashtra",
      "district": "Jalgaon",
      "voltageLevelKv": 220,
      "installedCapacityMw": 250,
      "feederCount": 4,
      "generatorCount": 5,
      "meterCount": 7,
      "status": "Active",
      "commissionDate": "24-Aug-2024"
    },
    {
      "code": "PSS-009",
      "name": "Kolhapur PSS 9",
      "qcaCode": "QCA-009",
      "qcaName": "MH_MSEDCL",
      "state": "Maharashtra",
      "district": "Latur",
      "voltageLevelKv": 400,
      "installedCapacityMw": 250,
      "feederCount": 4,
      "generatorCount": 5,
      "meterCount": 7,
      "status": "Active",
      "commissionDate": "27-Sep-2024"
    },
    {
      "code": "PSS-010",
      "name": "Amravati PSS 10",
      "qcaCode": "QCA-010",
      "qcaName": "MH_SHARDA",
      "state": "Maharashtra",
      "district": "Latur",
      "voltageLevelKv": 132,
      "installedCapacityMw": 400,
      "feederCount": 6,
      "generatorCount": 5,
      "meterCount": 7,
      "status": "Active",
      "commissionDate": "02-Oct-2024"
    },
    {
      "code": "PSS-011",
      "name": "Nagpur PSS 11",
      "qcaCode": "QCA-011",
      "qcaName": "MH_RATNAGIRI",
      "state": "Maharashtra",
      "district": "Mumbai",
      "voltageLevelKv": 220,
      "installedCapacityMw": 250,
      "feederCount": 4,
      "generatorCount": 5,
      "meterCount": 7,
      "status": "Active",
      "commissionDate": "05-Nov-2024"
    },
    {
      "code": "PSS-012",
      "name": "Kolhapur PSS 12",
      "qcaCode": "QCA-012",
      "qcaName": "MH_FERMI",
      "state": "Maharashtra",
      "district": "Aurangabad",
      "voltageLevelKv": 220,
      "installedCapacityMw": 300,
      "feederCount": 4,
      "generatorCount": 5,
      "meterCount": 7,
      "status": "Active",
      "commissionDate": "08-Dec-2024"
    },
    {
      "code": "PSS-013",
      "name": "Jalgaon PSS 13",
      "qcaCode": "QCA-013",
      "qcaName": "MH_UNILINK",
      "state": "Maharashtra",
      "district": "Latur",
      "voltageLevelKv": 400,
      "installedCapacityMw": 250,
      "feederCount": 4,
      "generatorCount": 5,
      "meterCount": 7,
      "status": "Active",
      "commissionDate": "11-Jan-2024"
    },
    {
      "code": "PSS-014",
      "name": "Aurangabad PSS 14",
      "qcaCode": "QCA-014",
      "qcaName": "MH_BULDHANA",
      "state": "Maharashtra",
      "district": "Aurangabad",
      "voltageLevelKv": 400,
      "installedCapacityMw": 500,
      "feederCount": 7,
      "generatorCount": 5,
      "meterCount": 7,
      "status": "Active",
      "commissionDate": "14-Feb-2024"
    },
    {
      "code": "PSS-015",
      "name": "Mumbai PSS 15",
      "qcaCode": "QCA-015",
      "qcaName": "MH_AVAADA_SUSTAIN",
      "state": "Maharashtra",
      "district": "Jalgaon",
      "voltageLevelKv": 132,
      "installedCapacityMw": 250,
      "feederCount": 4,
      "generatorCount": 5,
      "meterCount": 7,
      "status": "Active",
      "commissionDate": "17-Mar-2024"
    },
    {
      "code": "PSS-016",
      "name": "Latur PSS 16",
      "qcaCode": "QCA-016",
      "qcaName": "MH_VARKUTE",
      "state": "Maharashtra",
      "district": "Latur",
      "voltageLevelKv": 220,
      "installedCapacityMw": 500,
      "feederCount": 7,
      "generatorCount": 5,
      "meterCount": 7,
      "status": "Active",
      "commissionDate": "20-Apr-2024"
    },
    {
      "code": "PSS-017",
      "name": "Latur PSS 17",
      "qcaCode": "QCA-017",
      "qcaName": "MH_YAVAT",
      "state": "Maharashtra",
      "district": "Solapur",
      "voltageLevelKv": 132,
      "installedCapacityMw": 500,
      "feederCount": 7,
      "generatorCount": 5,
      "meterCount": 7,
      "status": "Active",
      "commissionDate": "23-May-2024"
    },
    {
      "code": "PSS-018",
      "name": "Satara PSS 18",
      "qcaCode": "QCA-018",
      "qcaName": "Wind Energy QCA 18",
      "state": "Maharashtra",
      "district": "Ahmednagar",
      "voltageLevelKv": 132,
      "installedCapacityMw": 100,
      "feederCount": 2,
      "generatorCount": 5,
      "meterCount": 7,
      "status": "Active",
      "commissionDate": "26-Jun-2024"
    },
    {
      "code": "PSS-019",
      "name": "Ahmednagar PSS 19",
      "qcaCode": "QCA-019",
      "qcaName": "Solar Energy QCA 19",
      "state": "Maharashtra",
      "district": "Latur",
      "voltageLevelKv": 400,
      "installedCapacityMw": 500,
      "feederCount": 7,
      "generatorCount": 5,
      "meterCount": 7,
      "status": "Active",
      "commissionDate": "01-Jul-2024"
    },
    {
      "code": "PSS-020",
      "name": "Kolhapur PSS 20",
      "qcaCode": "QCA-020",
      "qcaName": "Hybrid Energy QCA 20",
      "state": "Maharashtra",
      "district": "Satara",
      "voltageLevelKv": 132,
      "installedCapacityMw": 100,
      "feederCount": 2,
      "generatorCount": 5,
      "meterCount": 7,
      "status": "Active",
      "commissionDate": "04-Aug-2024"
    }
  ],
  "generatingCompanyCatalog": [
    {
      "registrationNo": "GC-0001",
      "entityName": "SolarOne Plant 1",
      "username": "solarone.plant.1-001",
      "email": "solarone.plant.1@gen-company.mock"
    },
    {
      "registrationNo": "GC-0002",
      "entityName": "WindStar Plant 2",
      "username": "windstar.plant.2-002",
      "email": "windstar.plant.2@gen-company.mock"
    },
    {
      "registrationNo": "GC-0003",
      "entityName": "SunPower Plant 3",
      "username": "sunpower.plant.3-003",
      "email": "sunpower.plant.3@gen-company.mock"
    },
    {
      "registrationNo": "GC-0004",
      "entityName": "SolarOne Plant 4",
      "username": "solarone.plant.4-004",
      "email": "solarone.plant.4@gen-company.mock"
    },
    {
      "registrationNo": "GC-0005",
      "entityName": "WindStar Plant 5",
      "username": "windstar.plant.5-005",
      "email": "windstar.plant.5@gen-company.mock"
    },
    {
      "registrationNo": "GC-0006",
      "entityName": "SolarOne Plant 6",
      "username": "solarone.plant.6-006",
      "email": "solarone.plant.6@gen-company.mock"
    },
    {
      "registrationNo": "GC-0007",
      "entityName": "GreenWind Plant 7",
      "username": "greenwind.plant.7-007",
      "email": "greenwind.plant.7@gen-company.mock"
    },
    {
      "registrationNo": "GC-0008",
      "entityName": "SunPower Plant 8",
      "username": "sunpower.plant.8-008",
      "email": "sunpower.plant.8@gen-company.mock"
    },
    {
      "registrationNo": "GC-0009",
      "entityName": "EcoHybrid Plant 9",
      "username": "ecohybrid.plant.9-009",
      "email": "ecohybrid.plant.9@gen-company.mock"
    },
    {
      "registrationNo": "GC-0010",
      "entityName": "SolarOne Plant 10",
      "username": "solarone.plant.10-010",
      "email": "solarone.plant.10@gen-company.mock"
    },
    {
      "registrationNo": "GC-0011",
      "entityName": "SunPower Plant 11",
      "username": "sunpower.plant.11-011",
      "email": "sunpower.plant.11@gen-company.mock"
    },
    {
      "registrationNo": "GC-0012",
      "entityName": "SunPower Plant 12",
      "username": "sunpower.plant.12-012",
      "email": "sunpower.plant.12@gen-company.mock"
    },
    {
      "registrationNo": "GC-0013",
      "entityName": "EcoHybrid Plant 13",
      "username": "ecohybrid.plant.13-013",
      "email": "ecohybrid.plant.13@gen-company.mock"
    },
    {
      "registrationNo": "GC-0014",
      "entityName": "EcoHybrid Plant 14",
      "username": "ecohybrid.plant.14-014",
      "email": "ecohybrid.plant.14@gen-company.mock"
    },
    {
      "registrationNo": "GC-0015",
      "entityName": "SolarOne Plant 15",
      "username": "solarone.plant.15-015",
      "email": "solarone.plant.15@gen-company.mock"
    }
  ],
  "pssGeneratingCompanyMappings": {
    "PSS-001": [
      "GC-0001",
      "GC-0117",
      "GC-0233"
    ],
    "PSS-002": [
      "GC-0002",
      "GC-0118",
      "GC-0234"
    ],
    "PSS-003": [
      "GC-0003",
      "GC-0119",
      "GC-0235"
    ],
    "PSS-004": [
      "GC-0004",
      "GC-0120",
      "GC-0236"
    ],
    "PSS-005": [
      "GC-0005",
      "GC-0121",
      "GC-0237"
    ],
    "PSS-006": [
      "GC-0006",
      "GC-0122",
      "GC-0238"
    ],
    "PSS-007": [
      "GC-0007",
      "GC-0123",
      "GC-0239"
    ],
    "PSS-008": [
      "GC-0008",
      "GC-0124",
      "GC-0240"
    ],
    "PSS-009": [
      "GC-0009",
      "GC-0125",
      "GC-0241"
    ],
    "PSS-010": [
      "GC-0010",
      "GC-0126",
      "GC-0242"
    ],
    "PSS-011": [
      "GC-0011",
      "GC-0127",
      "GC-0243"
    ],
    "PSS-012": [
      "GC-0012",
      "GC-0128",
      "GC-0244"
    ],
    "PSS-013": [
      "GC-0013",
      "GC-0129",
      "GC-0245"
    ],
    "PSS-014": [
      "GC-0014",
      "GC-0130",
      "GC-0246"
    ],
    "PSS-015": [
      "GC-0015",
      "GC-0131",
      "GC-0247"
    ],
    "PSS-016": [
      "GC-0016",
      "GC-0132",
      "GC-0248"
    ],
    "PSS-017": [
      "GC-0017",
      "GC-0133",
      "GC-0249"
    ],
    "PSS-018": [
      "GC-0018",
      "GC-0134",
      "GC-0250"
    ],
    "PSS-019": [
      "GC-0019",
      "GC-0135",
      "GC-0251"
    ],
    "PSS-020": [
      "GC-0020",
      "GC-0136",
      "GC-0252"
    ]
  }
}
